import { useMemo } from 'react';
import { batch, useDispatch } from 'react-redux';
import Link from 'next/link';
import { stringify } from 'qs';
import { v4 as createGuid } from 'uuid';

import { ISpecOffer } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { IDefaultPopup } from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { RubleSymbol } from '@r1-frontend/ui-react/tokens/symbols';

import { createTransaction } from '~/src/features/payments-abn/store/actions';
import { specialOfferAnalytics } from '~/src/features/specialOffersContainer/analytics';
import { LkPromotionalPopupExtra } from '~/src/features/specialOffersContainer/containers/popups/LkPromotionalPopupExtra';
import { setIsPopupOpened, setOfferTransaction, setPopupState } from '~/src/features/specialOffersContainer/store/actions';

export const PromoNeedPaymentPopup = ({ offer, ...props }: IDefaultPopup & { offer: ISpecOffer }) => {
    const transaction = createGuid();

    const paymentUrl = useMemo(() => `/payments?${stringify({ s: offer.paySum, transaction })}`, [offer.paySum, transaction]);

    const dispatch = useDispatch();

    const onPayHandler = () => {
        batch(() => {
            dispatch(createTransaction(transaction));
            dispatch(setOfferTransaction(transaction));
            dispatch(setPopupState('none'));
            dispatch(setIsPopupOpened(false));
        });
        specialOfferAnalytics.refillBalance(`discounts:${offer.title}`);
    };

    return (
        <LkPromotionalPopupExtra
            message='Недостаточно средств'
            icon={false}
            text={`Чтобы воспользоваться предложением, пополните счёт на ${offer.paySum} ${RubleSymbol}. `}
            buttons={(onClose) => [
                <Link
                    key={'btnToPayment'}
                    href={paymentUrl}
                    passHref
                >
                    <Button
                        data-test={'LkPromotionalPopupExtra-btntoactions'}
                        onClick={onPayHandler}
                    >
                        Пополнить
                    </Button>
                </Link>,
                <Button
                    key={'btnClose'}
                    onClick={onClose}
                    bType={'secondary'}
                    data-test={'LkPromotionalPopupExtra-btnclose'}
                >
                    Закрыть
                </Button>,
            ]}
            {...props}
        />
    );
};
